import './styles.scss'
import React, { memo } from 'react'
import Lottie from 'lottie-react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { UnFilledHeartIcon, FilledHeartIcon } from 'Assets/Icons'
import { ROUTE_STRINGS } from 'Utils/Constants'

export const LocationCard = memo(({ item, isActive, onLocationClick, getCurrentDateForTimezone, getCurrentTimeForTimezone, getWeatherConditionIcon, getWeatherLottieAsset, onAddLocation, onRemoveLocation, userDetails, weatherData, setWeatherData }) => {
  const { t } = useTranslation()

  const locationId = item?.location_id || item?.id
  const weatherCondition = item?.weather?.weather_condition
  const locationDateTime = item?.timezone ? new Date(new Date().toLocaleString('en-US', { timeZone: item.timezone })) : new Date()
  const conditionIcon = getWeatherConditionIcon(weatherCondition, false, locationDateTime)
  const isConditionIconImage = typeof conditionIcon === 'string'

  const history = useHistory()

  const backgroundAnimation = getWeatherLottieAsset(item?.weather?.weather_condition, locationDateTime)
  const isBackgroundImage = typeof backgroundAnimation === 'string'
  const handleClick = (event, item) => {
    const updatedValue = !item?.isInUserLocation

    if (!userDetails) {
      history.push(ROUTE_STRINGS.login)
    }
    setWeatherData((prevData) => prevData?.map((loc) => (loc.location_id === item.location_id ? { ...loc, isInUserLocation: updatedValue } : loc)))

    if (item?.isInUserLocation) {
      onRemoveLocation(userDetails?.id, item?.location_id, item?.location_name, false, event)
    } else {
      onAddLocation(event, item, false)
    }
  }

  return (
    <div className={`location-card ${isActive ? 'active' : ''}`} onClick={() => onLocationClick(locationId)} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && onLocationClick(locationId)}>
      <div className="location-card-background">{isBackgroundImage ? <img src={backgroundAnimation} alt="Weather background" className="weather-background-animation" /> : <Lottie animationData={backgroundAnimation} loop={true} className="weather-background-animation" />}</div>
      <div className="location-card-content">
        <div className="location-card-header">
          <div className="location-date-time-wrapper">
            <div className="location-date-time-container">
              <div className="location-date">{getCurrentDateForTimezone(item?.timezone, 'spaceFormat')}</div>
              <div className="location-date">{getCurrentTimeForTimezone(item?.timezone)}</div>
            </div>
          </div>

          <div className="location-condition-icon">{isConditionIconImage ? <img src={conditionIcon} alt={weatherCondition || 'Weather'} className="weather-animation-small" /> : <Lottie animationData={conditionIcon} loop={true} className="weather-animation-small" />}</div>

          <div className="location-temp-large">
            <div className="location-radio-wrapper">{isActive && item?.weather?.temperature && <input type="radio" name="location" value={item?.location_name} defaultChecked />}</div>
            <div className="location-temp-large-value"> {item?.weather?.temperature ? `${Number(item.weather.temperature).toFixed(0)}°C` : '-'}</div>
          </div>
        </div>

        <div className="location-card-body">
          <div></div> {/* for ui purposes */}
          <div className="location-city">
            {item.location_name}
            {item?.zone && (
              <span className="location-zone">
                {t('ZONE')} {item?.zone}
              </span>
            )}
          </div>
          <div className="add-otherlocation">
            <i className="heart-icon" onClick={(event) => handleClick(event, item)}>
              {item?.isInUserLocation ? <FilledHeartIcon /> : <UnFilledHeartIcon />}
            </i>
          </div>
        </div>

        <div className="location-card-footer">
          <div className="location-condition">{item?.weather?.weather_condition}</div>
          <div className="location-high-low">
            H:{item?.weather?.high_temperature ? `${Number(item?.weather?.high_temperature).toFixed(0)}°C` : '-'} L:{item?.weather?.low_temperature ? `${Number(item?.weather?.low_temperature).toFixed(0)}°C` : '-'}
          </div>
        </div>
      </div>
    </div>
  )
})

LocationCard.displayName = 'LocationCard'
